module.exports = __webpack_public_path__ + "static/media/content-03-m.d0daa137.png";